import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import TextField from '@mui/material/TextField';
import { trainingCost } from '../../constants/global';
import FormControl from '@mui/material/FormControl';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Alert from '@mui/material/Alert';
// import moment from 'moment';

const useStyles = makeStyles({
    deleteDialogButton: {
        backgroundColor: "#d90000",
        color: 'white',
        '&:hover': {
            backgroundColor: "#d90000",
            color: 'white'
        }
    }
});



export default function DeleteDialog(props) {
    const classes = useStyles();

    return (
        <Dialog
            open={props.open}
            onClose={props.onClose}
            aria-labelledby="delete-dialog-title"
            aria-describedby="delete-dialog-description"
        >
            <DialogTitle id="delete-dialog-title">{"Confirm Delete"}</DialogTitle>
            <DialogContent>
                <DialogContentText id="delete-dialog-description">
                    Are you sure you want to delete?
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={props.onClose} variant="outlined" >
                    Cancel
                </Button>
                <Button onClick={props.onDelete} variant="contained" className={[classes.deleteDialogButton].join(' ')}>
                    Delete
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export function CancelDialog(props) {
    const classes = useStyles();

    return (
        <Dialog
            open={props.open}
            onClose={props.onClose}
            aria-labelledby="cancel-dialog-title"
            aria-describedby="cancel-dialog-description"
        >
            <DialogTitle id="cancel-dialog-title">{"Confirm Cancellation"}</DialogTitle>
            <DialogContent>
                <DialogContentText id="cancel-dialog-description">
                    Please provide a reason for the class cancellation
                </DialogContentText>
                <TextField
                    autoFocus
                    margin="dense"
                    id="reason"
                    label="Cancellation reason"
                    type="text"
                    onChange={props.onChange}
                    value={props.value}
                    fullWidth
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={props.onClose} variant="outlined" >
                    Back
                </Button>
                <Button onClick={props.onDelete} 
                    variant="contained" 
                    disabled={props.disabled}
                    className={[classes.deleteDialogButton].join(' ')}>
                    Confirm
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export function WaiveDialog(props) {
    return (
        <Dialog
            open={props.open}
            onClose={props.onClose}
            aria-labelledby="dialog-title"
            aria-describedby="dialog-description"
        >
            <DialogTitle id="dialog-title">{"Waiver Required"}</DialogTitle>
            <DialogContent>
                <DialogContentText id="dialog-description">
                    Warning: To complete your class submission, you must complete a 30-Day Waiver Request (link below).
                    This class will not be published or eligible to provide GI-BMP certificates until your waiver request
                    is approved by your Regional Coordinator. You will receive an email notice when the class has been approved.
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={props.onClose} variant="outlined" >
                    Back
                </Button>
                <Button onClick={props.onConfirm} variant="contained" color="primary" className={[].join(' ')}>
                    Waiver Request
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export function SuccessfulWaiveDialog(props) {

    return (
        <Dialog
            open={props.open}
            onClose={props.onClose}
            aria-labelledby="dialog-title"
            aria-describedby="dialog-description"
        >
            <DialogTitle id="dialog-title">Waiver Request Submitted</DialogTitle>
            <DialogContent>
                <DialogContentText id="dialog-description">
                    Your request for a 30-day waiver for this class has been sent to your Regional Coordinator for approval..
                    <br />
                    You will receive an email when the class is approved.
                    <br/>
                    Class ID:{props.classID}
                    <br/>
                    Class date:{props.classDate}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={props.onClose} variant="contained" color="primary" className={[].join(' ')}>
                    OK
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export function PolicyDialog(props) {
    return (
        <Dialog
            open={props.open}
            onClose={props.onClose}
            aria-labelledby="dialog-title"
            aria-describedby="dialog-description"
        >
            <DialogTitle id="dialog-title">Student Policies for GI-BMP Online or DVD Training</DialogTitle>
            <DialogContent>
                {/* <DialogContentText id="dialog-description"> */}
                <ol>
                    <li>The student can download the <a href="https://ffl.ifas.ufl.edu/ffl-and-you/gi-bmp-program/gi-bmp-manual" target="_blank" rel="noreferrer">GI-BMP manual</a>, or obtain a printed copy from his/her local Extension office.</li>
                    <li>The training program consists of multiple sections or &quot;modules&quot;. The entire content of all modules must be viewed. In addition:
                        <ul>
                            <li><strong>For online training,</strong> the student must pass a review quiz at the end of each module with a score of 75% or higher. The review quiz can be repeated until a passing score is achieved.</li>
                            <li><strong>For DVD training,</strong> the student must sign an affidavit of completion indicating that all modules have been completed.</li>
                        </ul>
                    </li>
                    <li><strong>To receive a GI-BMP Certificate of Training, the student must pass a certification post-test with a score of 75% or higher.</strong> The post-test covers material from all training modules. <strong>The student cannot take the post-test until all modules are completed.</strong></li>
                    <li>The certification post-test must be taken within 6 months of completing the training. The student has the option to take the test online, or to print a voucher to take the test in person at a county Extension office. A GI-BMP Instructor or FDACS CPCO/L&amp;O license holder may also arrange to proctor a test for the student.
                        <ul>
                            <li><strong>For online tests,</strong> the student must accept an oath stating that he/she is doing his/her own work without help. <strong>The online test must be taken in one session, with a one-hour time limit.</strong></li>
                            <li><strong>For in-person tests,</strong> the student must present the testing voucher and personal identification at an Extension office, either by appointment or at a designated testing time. Or, arrangements may be made with another authorized proctor.</li>
                        </ul></li>
                    <li><strong>The student has the option to re-take the post-test one time,</strong> either online or in person, if a passing score is not achieved on the first attempt. There is no &quot;wait time&quot; requirement; however, the student is encouraged to review the modules and study the manual before retaking the test.</li>
                    <li><strong>If a passing score (75%) is achieved</strong> on the first or second certification post-test <strong>a GI-BMP certificate of training will be mailed</strong> to the address indicated in the student profile. Certificates are usually mailed on the following business day after the online test is completed or the <span>in-person</span> test is received by mail. An email copy can be requested by contacting <a href="mailto:gi.bmp@ifas.ufl.edu">gi.bmp@ifas.ufl.edu</a> or 352-273-4517.</li>
                    <li><strong>If a passing score is NOT achieved on the second certification test, no certificate of training will be issued for the online or DVD training.</strong> To receive a certificate, the student must attend <span>in-person</span> training, including paying the required class fee, attending the entire training, and taking and passing the post-test.</li>
                    <li><strong>FDACS CEU's are not available for the online or DVD versions of the GI-BMP training.</strong></li>
                </ol>
                {/* </DialogContentText> */}
            </DialogContent>
            <DialogActions>
                <Button onClick={() => window.print()} variant="contained" color="primary" className={[].join(' ')}>
                    Print
                </Button>
                <Button onClick={props.onClose} variant="contained" color="primary" className={[].join(' ')}>
                    Close
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export function ModuleDialog(props) {
    // const classes = useStyles();

    return (
        <Dialog
            open={props.open}
            onClose={props.onClose}
            aria-labelledby="dialog-title"
            aria-describedby="dialog-description"
        >
            {/* <DialogTitle id="dialog-title" dangerouslySetInnerHTML={{__html: props.title}} /> */}
            <DialogTitle id="dialog-title" ><span dangerouslySetInnerHTML={{ __html: props.title }}></span></DialogTitle>
            <DialogContent>
                <DialogContentText id="dialog-description" dangerouslySetInnerHTML={{ __html: props.description }} />
            </DialogContent>
            <DialogActions>
                <Button onClick={props.onClose} variant="contained" color="primary" className={[].join(' ')}>
                    Close
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export function ConfirmPayDialog(props) {
    // const classes = useStyles();

    return (
        <Dialog
            open={props.open}
            onClose={props.onClose}
            aria-labelledby="dialog-title"
            aria-describedby="dialog-description"
        >
            {/* <DialogTitle id="dialog-title" dangerouslySetInnerHTML={{__html: props.title}} /> */}
            <DialogTitle id="dialog-title" >Confirm Payment</DialogTitle>
            <DialogContent>
                {/* <h1>Confirm Payment:</h1> */}
                <p>You currently have ${props.data && props.data.credit} credit.</p>
                <p>Training cost: ${trainingCost}</p>
                <p>After payment, you will have: ${props.data && props.data.credit-trainingCost} credit.</p>
            </DialogContent>
            <DialogActions>
                <Button onClick={props.onClose} variant="outlined" color="primary" className={[].join(' ')}>
                    Close
                </Button>
                <Button onClick={props.onConfirm} variant="contained" color="primary" disabled={!(props.data && props.data.credit>=trainingCost)}>
                    Confirm and Pay
                </Button>
            </DialogActions>
        </Dialog>
    );
}


export function AddCreditDialog(props) {
    return (
        <Dialog
            open={props.open}
            onClose={props.onClose}
            aria-labelledby="addCredit-dialog-title"
            aria-describedby="addCredit-dialog-description"
        >
            <DialogTitle id="addCredit-dialog-title">{"Add Credit"}</DialogTitle>
            <DialogContent>
                <DialogContentText id="addCredit-dialog-description">
                    Please provide the amount of credit to add, and a note 
                </DialogContentText>
                 <TextField
                    id="amount"
                    label="Amount"
                    type="number"
                    defaultValue={trainingCost}
                    onChange={props.onAmountChange}
                    fullWidth
                />
                <TextField
                    autoFocus
                    margin="dense"
                    id="notes"
                    label="notes for adding credit"
                    type="text"
                    defaultValue="Courtesy Credit from GI-BMP Office"
                    onChange={props.onNotesChange}
                    fullWidth
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={props.onClose} variant="outlined" >
                    Cancel
                </Button>
                <Button onClick={props.onAddCredit} variant="contained" className={[].join(' ')}>
                    Add
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export function RefundInitiate(props) {
    return (
        <Dialog
            open={props.open}
            onClose={props.onClose}
            aria-labelledby="addCredit-dialog-title"
            aria-describedby="addCredit-dialog-description"
        >
            <DialogTitle id="addCredit-dialog-title">{"Initiate Refund"}</DialogTitle>
            <DialogContent>
                <DialogContentText id="addCredit-dialog-description">
                    Please provide details of the transaction to initiate refund 
                    {props.error &&
                                        <>
                                            <Alert severity="error" >{props.mainError}</Alert>
                                            <br />
                                        </>
                                    }
                </DialogContentText>
                 <TextField
                    id="amount"
                    label="Amount"
                    type="number"
                    onChange={props.onAmountChange}
                    value = {props.presentAmountValue}
                    fullWidth
                />
                <TextField
                    autoFocus
                    margin="dense"
                    id="Refund"
                    label="Reason"
                    type="text"
                    defaultValue="Refunded to Card"
                    onChange={props.onReasonChange}
                    fullWidth
                />
                <TextField
                    autoFocus
                    margin="dense"
                    id="notes"
                    label="Request Date"
                    type="text"
                    value={props.date}
                    readOnly = {true}
                    fullWidth
                />

                <FormControl component="fieldset" className={[].join(' ')}>
                     
                        <FormGroup>
                        <FormControlLabel
                            control={<Checkbox checked={props.CheckedValue} onChange={props.onChangeDeductCredit} name="Deduct Credit" />}
                            label="Deduct Credit"
                        />
                        </FormGroup>
                    </FormControl>
                
                
            </DialogContent>
            <DialogActions>
                <Button onClick={props.onClose} variant="outlined" >
                    Cancel
                </Button>
                <Button onClick={props.onRefundClick} variant="contained" className={[].join(' ')}>
                    Refund
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export function EnterRefundDetails(props) {
    return (
        <Dialog
            open={props.open}
            onClose={props.onClose}
            aria-labelledby="addCredit-dialog-title"
            aria-describedby="addCredit-dialog-description"
        >
            <DialogTitle id="addCredit-dialog-title">{"Complete Refund"}</DialogTitle>
            <DialogContent>
                <DialogContentText id="addCredit-dialog-description">
                    Please provide details of the refund transaction 
                </DialogContentText>
                <TextField
                    autoFocus
                    id="processedDate"
                    label="Date Processed"
                    type="date"
                    value={props.processedDate}
                    name="processedDate"
                    onChange={props.onDateChange}
                    InputLabelProps={{
                      shrink: true
                    }}
                    fullWidth
                    required
                />
           
                <TextField
                    margin="dense"
                    id="voucherID"
                    label="Voucher ID"
                    type="text"
                    value={props.voucherID}
                    onChange={props.onVocherChange}
                    fullWidth
                    required
                />
                
                
            </DialogContent>
            <DialogActions>
                <Button onClick={props.onClose} variant="outlined" >
                    Cancel
                </Button>
                <Button onClick={props.onRefundClick} variant="contained" className={[].join(' ')}>
                    Update
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export function EnterNewUsedByDate(props) {
    return (
        <Dialog
            open={props.open}
            onClose={props.onClose}
            aria-labelledby="addCredit-dialog-title"
            aria-describedby="addCredit-dialog-description"
        >
            <DialogTitle id="addCredit-dialog-title">{"Update Training Code"}</DialogTitle>
            <DialogContent>
                <DialogContentText id="addCredit-dialog-description">
                    To change the deadline for taking the test, edit the “Used By” date
                </DialogContentText>
                <TextField
                    id="serialNumber"
                    label="Training Code"
                    type="text"
                    value={props.serialNumber}
                    name="serialNumber"
                    fullWidth
                    disabled
                />
                <TextField
                    id="trainingType"
                    label="Training Type"
                    type="text"
                    value={props.trainingType}
                    name="trainingType"
                    fullWidth
                    disabled
                />
           
                <TextField
                    autoFocus
                    id="usedBy"
                    label="Used By"
                    type="date"
                    // value={props.usedBy ? moment(props.usedBy).format('MM-DD-YYYY') : ''}
                    value={props.usedBy}
                    name="usedBy"
                    onChange={props.onDateChange}
                    InputLabelProps={{
                    shrink: true
                    }}
                    fullWidth
                    required
                />
                <div className='errorMessage' 
                style= {{ display: `${ (props.usedBy!=null) || props.valid ? 'none' : 'inline'}`  }}
                 >Enter Valid Used by Date</div>
                
                
            </DialogContent>
            <DialogActions>
                <Button onClick={props.onClose} variant="outlined" >
                    Cancel
                </Button>
                <Button onClick={props.onRefundClick} variant="contained" className={[].join(' ')}>
                    Update
                </Button>
            </DialogActions>
        </Dialog>
    );
}